import { render, staticRenderFns } from "./carCmp.vue?vue&type=template&id=2f2526c0&scoped=true&"
import script from "./carCmp.vue?vue&type=script&lang=js&"
export * from "./carCmp.vue?vue&type=script&lang=js&"
import style0 from "./carCmp.vue?vue&type=style&index=0&id=2f2526c0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2526c0",
  null
  
)

export default component.exports